import React from "react";
import MaterialModal from "components/modal/MaterialModal";
import Link from "next/link";

/* 로그인 모달 */
const LoginModal = ({ modalVisible, closeModal }) => {
  return (
    <MaterialModal open={modalVisible} closeModal={closeModal}>
      <div className="popup-content">
        <div className="popup-header"></div>
        <div className="popup-body flex flex-col justify-center items-center">
          <h3 className="text-2xl text-primary font-bold font-gmarket-medium" id="modal-title">
            로그인 후 이용하실 수 있습니다.
          </h3>
          <p className="mb-0 text-888 font-gmarket-medium">로그인하기 버튼을 클릭하여 아이소 로그인해주세요.</p>
        </div>
        <div className="popup-footer">
          <button type="button" className="btn btn-modal-o w-1/2 mr-2" onClick={closeModal}>
            확인
          </button>
          <Link href="/signin">
            <div className="btn btn-grayPrimary w-1/2">로그인하기</div>
          </Link>
        </div>
      </div>
    </MaterialModal>
  );
};

export default LoginModal;
